
import axios from "axios";
const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;

export const deleteResource = async (resource, request) => {
  let params = {
    method: "DELETE",
    headers: {},
  };

  params["headers"]["Content-Type"] = "application/json";
  params["body"] = JSON.stringify(request);

  try {
    let response = await fetch(resource, params);
    if (!response.ok) {
      const json = await response.json();
      throw json;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const sortArrayOfHashesByOrderedArray = (hashArray, propName, orderedArray) => {
  const orderIndex = new Map(
    orderedArray.map((value, index) => [value, index])
  );

  return [...hashArray].sort((a, b) => {
    const aVal = a[propName];
    const bVal = b[propName];

    const aIndex = orderIndex.has(aVal) ? orderIndex.get(aVal) : Infinity;
    const bIndex = orderIndex.has(bVal) ? orderIndex.get(bVal) : Infinity;

    return aIndex - bIndex;
  });
};

export const formatMMDDYYYY = (date) => {
  if (!(date instanceof Date) || isNaN(date)) return null;

  const month = String(date.getMonth() + 1);
  const day   = String(date.getDate());
  const year  = date.getFullYear();

  return `${month}/${day}/${year}`;
}

export const alphaVal = (s) => s.toLowerCase().charCodeAt(0) - 97 + 1;


export const postReq = async (resource, request) => {
  let params = {
    method: "POST",
    headers: {
      'X-CSRF-Token': csrfToken(),
      'Accept': "application/json",
      'Content-Type': "application/json",
    },
    'body': JSON.stringify(request)
  };

  let response = await fetch(resource, params);
  if (!response.ok) {
    const json = await response.json();
    const errorMessage = json['error'] || json['message'];
    alert(errorMessage);
    throw new Error(errorMessage);
  }
  const data = await response.json();
  return data;
};

export const fetchResource = async (resource) => {
  try {
    let response = await fetch(resource);

    if (!response.ok) {
      const json = await response.json();
      throw json;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const postToResource = async (resource, request) => {
  let params = {
    method: "POST",
    headers: {
      'X-CSRF-Token': csrfToken(),
    },
  };
  if (request && request.constructor.name == "FormData") {
    params["body"] = request;
    params["headers"]["enctype"] = "multipart/form-data";
    params["headers"]["async"] = true;
    params["headers"]["cache"] = false;
    params["headers"]["contentType"] = false;
    params["headers"]["processData"] = false;
  } else {
    params["headers"]["Accept"] = "application/json";
    params["headers"]["Content-Type"] = "application/json";
    params["headers"]["cache"] = false;
    params["body"] = JSON.stringify(request);
  }

  let response = await fetch(resource, params);
  if (!response.ok) {
    const json = await response.json();
    throw json;
  }
  const data = await response.json();
  return data;
};

export const updateToResource = async (resource, request) => {
  var params = {
    method: "PUT",
    headers: {
      "X-CSRF-Token": csrfToken(),
    },
  };

  if (request.constructor.name == "FormData") {
    params["body"] = request;
    params["headers"]["enctype"] = "multipart/form-data";
    params["headers"]["async"] = true;
    params["headers"]["cache"] = false;
    params["headers"]["contentType"] = false;
    params["headers"]["processData"] = false;
  } else {
    params["headers"]["Content-Type"] = "application/json";
    params["body"] = JSON.stringify(request);
  }

  let response = await fetch(resource, params);

  if (!response.ok) {
    const errorText = await response.json();
    const errorMessage = errorText['error'] || errorText['message'];
    alert(errorMessage);
    throw new Error(errorMessage);
  }
  let content = response;
  return content;
};
